import {$} from './jquery-definition.js';
import 'is-in-viewport';

var $scrollProgressContainer = $( '.featured-header-scroll-progress-container' );
var $scrollProgress = $( '.featured-header-scroll-progress' );
var scrollProgressContainerWidth = $scrollProgressContainer.width();
var scrollProgressWidth = $scrollProgress.width();
var availableProgressLength = scrollProgressContainerWidth - scrollProgressWidth;

$( function() {
	animateInViewport();
	setProgressWidths();
} );

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );

	updateFeaturedHeader()
} );

$( updateFeaturedHeader );

function updateFeaturedHeader() {
	var windowHeight = $( window ).height();
	var scrollOffset = $( document ).scrollTop();

	if ( scrollOffset > $( window ).height() * 2 + 200 ) {
		$( '.featured-header' ).removeClass( 'active' );
	} else {
		$( '.featured-header' ).addClass( 'active' );
	}

	var overlayOffset = (scrollOffset < windowHeight) ? (100 / windowHeight * scrollOffset) : 100;
	var opacity = (100 - overlayOffset) / 100;
	$( '.featured-header-overlay, .featured-header-logo-container' ).css( {
		'opacity': opacity
	} );
}

$( window ).on( 'resize', function() {
	setTimeout( function() {
		setProgressWidths();
	}, 100 );
} );

function animateInViewport() {
	$( '.move-up-in-viewport, .move-down-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .full-width-in-viewport, .graphic' ).each( function() {
		var $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}

function setProgressWidths() {
	scrollProgressContainerWidth = $scrollProgressContainer.width();
	scrollProgressWidth = $scrollProgress.width();
	availableProgressLength = scrollProgressContainerWidth - scrollProgressWidth;
}
